import React from "react";

export default function () {
  window.location.href =
    "https://possibleworld.getoutline.com/share/1aaa0d19-34e6-4185-b54e-0075335fc552";

  return <div></div>;
}
